import { createStore } from 'vuex'
import api from '../services/Axios'


import { listCustomerController } from "../controllers/Customer/ListCustomerController"
import { listPackageController } from '../controllers/Packager/listPackageController'
import { listModelController } from "../controllers/Model/ListModelController"
import { listCpcController } from '../controllers/Cpc/ListCpcController'
import { listUserController } from '../controllers/User/ListUserController'
import { InstanceAllController } from '../controllers/Instance/InstanceAllController'

export default createStore({
    state: {

        statusModal: 1,
        isLoading: false,
        userLogged: {},
        usuarios: [],
        clientes: [],
        embalagens: [],
        modelos: [],
        cpc: [],
        imgURL: `https://apirastreabilidade.tutilabs.com.br/static/`
    },
    mutations: {

        STATUS_MODAL(state, novoStatus) {
            state.statusModal = novoStatus
        },

        CHANGE_LOADING(state) {
            state.isLoading = !state.isLoading
        },

        USER_LOGGED(state, user) {
            state.userLogged = user
        },

        GET_CLIENTE(state, clientes) {
            state.clientes = clientes
        },

        GET_EMBALAGENS(state, embalagens) {
            state.embalagens = embalagens
        },

        GET_MODELOS(state, modelo) {
            state.modelos = modelo
        },

        GET_CPC(state, cpc) {
            state.cpc = cpc
        },

        GET_USUARIOS(state, users) {
            state.usuarios = users
        },

        INSTANCIAR_STATE(state, { clientes, modelos, embalagens, cpc, users }) {
            state.clientes = clientes
            state.modelos = modelos
            state.embalagens = embalagens
            state.cpc = cpc
            state.usuarios = users
        }

    },
    actions: {

        async instanciarState(context) {
            // try {

            //     // context.commit("CHANGE_LOADING")

            //     // const { users, embalagens, customers, cpcs, models } = await InstanceAllController()

            //     // context.commit("INSTANCIAR_STATE", { clientes: customers, modelos: models, embalagens, cpc: cpcs, users })

            //     // context.commit("CHANGE_LOADING")

            // } catch (error) {
            //     return console.log(error)
            // }
        },

        async getCliente(context) {
            // try {

            //     context.commit("CHANGE_LOADING")

            //     const clientes = await listCustomerController()


            //     if (clientes instanceof Error) {
            //         context.commit("CHANGE_LOADING")
            //         return
            //     }

            //     context.commit("GET_CLIENTE", clientes)

            // } catch (e) {
            //     return console.log(e)
            // }

        },

        async getEmbalagens(context) {

            // try {

            //     context.commit("CHANGE_LOADING")

            //     const embalagens = await listPackageController()

            //     context.commit("CHANGE_LOADING")

            //     context.commit("GET_EMBALAGENS", embalagens)
            // } catch (e) {
            //     return e
            // }
        },

        async getModelos(context) {
            // try {

            //     context.commit("CHANGE_LOADING")

            //     const modelos = (await api.get("models")).data

            //     context.commit("CHANGE_LOADING")

            //     if (modelos.length < 0) {
            //         return console.log("errou")
            //     }

            //     context.commit("GET_MODELOS", modelos)


            // } catch (error) {
            //     return console.log(error)
            // }
        },

        async getCpc(context) {
            // try {

            //     context.commit("CHANGE_LOADING")

            //     const cpc = await listCpcController()

            //     context.commit("CHANGE_LOADING")


            //     if (cpc.length < 0) {
            //         return console.log("errou")
            //     }

            //     context.commit("GET_CPC", cpc)

            // } catch (error) {
            //     return console.log(error)
            // }
        },

        async getUsers(context) {
            // try {

            //     context.commit("CHANGE_LOADING")

            //     const users = await listUserController()

            //     context.commit("CHANGE_LOADING")

            //     if (users < 0) {
            //         return console.log("errou")
            //     }

            //     context.commit("GET_USUARIOS", users)

            // } catch (error) {
            //     context.commit("GET_USUARIOS", users)
            //     return console.log(error)
            // }
        },

        alterarStatusModal(context, novoStatus) {
            context.commit("STATUS_MODAL", novoStatus)
        },

        userLogged(context, user) {
            context.commit("USER_LOGGED", user)
        }

    },
    getters: {

        changeStatus(state) {
            return state.statusModal
        },

        changeLoad(state) {
            return state.isLoading
        },

        listarCliente(state) {
            return state.clientes
        },
        listarEmbalagem(state) {
            return state.embalagens
        },

        listarModelos(state) {
            return state.modelos
        },

        listarCpc(state) {
            return state.cpc
        },

        listarUsuario(state) {
            return state.usuarios
        },

        listarUsuarioLogado(state) {
            return state.userLogged
        }

    }
})
